import { PageHeader } from "../components/PageHeader";
import { BUSINESS } from "../config";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="text-xl font-semibold font-heading">{title}</h2>
    <div className="mt-3 text-base text-[#525252] leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHeader
        label="Policies"
        title="Privacy Policy"
        description="How Zum Flooring handles your information when you use this website or request a quote."
        testId="privacy-header"
      />
      <div className="max-w-3xl mx-auto px-6 py-16" data-testid="privacy-content">
        <Section title="What we collect">
          <p>
            When you request a quote or contact us through this website, we collect the details you provide —
            your name, phone number, email address, property address or suburb, flooring requirements and any
            photos or floor plans you upload.
          </p>
        </Section>
        <Section title="How we use it">
          <p>
            We only use your details to respond to your flooring enquiry, prepare your quote, and arrange and
            carry out your flooring work. We do not sell, rent or share your personal information with third
            parties for marketing.
          </p>
        </Section>
        <Section title="Photos and files you upload">
          <p>
            Photos and floor plans you send us are stored securely and used only to assess and quote your job.
            With your permission, completed project photos may be shown in our Recent Projects gallery — we
            never publish your private address.
          </p>
        </Section>
        <Section title="Storage and security">
          <p>
            Your information is stored securely and only kept for as long as needed to handle your enquiry and
            any work that follows. You can ask us to update or delete your details at any time.
          </p>
        </Section>
        <Section title="Contact us about privacy">
          <p>
            Questions about your information? Contact us at{" "}
            <a href={`mailto:${BUSINESS.email}`} className="text-[#C87A38] hover:underline" data-testid="privacy-email-link">
              {BUSINESS.email}
            </a>{" "}
            or call {BUSINESS.phoneDisplay}.
          </p>
        </Section>
        <p className="mt-12 text-xs text-[#A3A3A3]" data-testid="privacy-updated">
          Last updated: August 2026. Zum Flooring, Melbourne VIC.
        </p>
      </div>
    </div>
  );
}
